module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-jekell.641017a9.png";